import axios from '../../axios'

/*
 * 材料数据接口
 */
// 上传课程资源
export const uploadCourseResource = (data) => {
    return axios({
        url: '/api/course/upload/resource',
        method: 'get',
        data
    })
}

// 查询课程资源上传状态
export const uploadStatus = (data) => {
    return axios({
        url: '/api/course/upload/status',
        method: 'get',
        data
    })
}

// 添加/修改/提审课程
export const addUpdataArraignment = (data) => {
    return axios({
        url: '/api/course/audit/commit',
        method: 'get',
        data
    })
}

// 修改课程状态
export const updataCourseStatus = (data) => {
    return axios({
        url: '/api/course/modify/status',
        method: 'get',
        data
    })
}

// 查询课程
export const searchCourse = (data) => {
    return axios({
        url: '/api/course/audit/query',
        method: 'get',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tiktok/coursetiktok.js